import {
  MAX_FULL_NAME_LENGTH,
  MAX_NAME_LENGTH,
  MAX_PASSWORD_LENGTH,
  MIN_AGE,
  MIN_PASSWORD_LENGTH,
} from '@/constants/Common'
import { LocaleConstant } from '../en/constant'

const constant: LocaleConstant = {
  emailInvalid: 'El Email no es válido.',
  emailRequired: 'Email obligatorio.',
  passRequired: 'Contraseña obligatoria.',
  passNoWhiteSpace: 'No se permiten espacios en blanco.',
  passMinLength: `La contraseña debe tener al menos ${MIN_PASSWORD_LENGTH} caracteres.`,
  passMaxLength: `La contraseña no debe tener más de ${MAX_PASSWORD_LENGTH} caracteres.`,
  passLettersNumbers: 'La contraseña debe contener letras y números',
  passOneNumbers: 'La contraseña debe contener al menos un número',
  passStrength: `Se requiere una contraseña de un mínimo de ${MIN_PASSWORD_LENGTH} caracteres que contenga una combinación de letras mayúsculas o minúsculas y números.`,
  passMatch: 'Introduzca una contraseña que coincida.',
  fullNameRequired: 'Nombre completo obligatorio.',
  fullNameNoSpecial: 'No se permiten números ni caracteres especiales.',
  fullNameNoWhitespace: 'No se permiten espacios en blanco.',
  fullNameMaxLength: `Sólo se permiten caracteres ${MAX_FULL_NAME_LENGTH}.`,
  nameMaxLength: `Sólo se permiten caracteres ${MAX_NAME_LENGTH}.`,
  typeDate: 'El formato de la fecha debe ser MM/DD/AAAA.',
  birthDateRequired: 'La fecha de nacimiento es obligatoria.',
  birthDateMin: `La edad mínima es de ${MIN_AGE} años.`,
  emailConfirm: 'Los correos electrónicos no coinciden.',
  locationRequired: 'Se requiere ubicación.',
  locationNeedsCity: 'Elige una ciudad o un pueblo. Un país por sí solo no es suficiente.',
  locationSaveFailed: 'No pudimos usar esa ubicación. Inténtalo de nuevo o elige otra.',
}

export default constant
